export default "__VITE_ASSET__ceea0447__"